import { downloadToolUsbToken } from "helpers/utils";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
// Redux
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Dropdown, DropdownMenu, DropdownToggle, Spinner } from "reactstrap";
import { AUTH_TOKEN, USER_INFO } from "store/auth/login/actionTypes";
// users
import user1 from "../../../assets/images/users/avatar-default.png";

const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);

  const Profile = useSelector(state => state.Profile);
  const { userInfo, avatar_id, avatarImg, loading } = Profile;

  const dispatch = useDispatch();
  const { t } = useTranslation("translation");

  const [userInfoDefault, setUserInfoDefault] = useState(false);
  useEffect(() => {
    const userInfo = localStorage.getItem(USER_INFO);
    if (userInfo) {
      setUserInfoDefault(JSON.parse(userInfo));
    }
    if (localStorage.getItem(AUTH_TOKEN)) {
      if (!userInfo) {
        // dispatch(getProfile());
      }
    }
  }, []);
  const history = useHistory();

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Spinner color="primary" />
            </div>
          ) : (
            <React.Fragment>
              <img
                className="rounded-circle header-profile-user"
                src={avatarImg ? avatarImg : user1}
                alt="Header Avatar"
              />
              <span className="d-none d-xl-inline-block ms-2 me-1">
                {userInfo?.display_name
                  ? userInfo.display_name
                  : userInfoDefault.userName}
              </span>
              <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
            </React.Fragment>
          )}
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <Link to="/profile" className="dropdown-item">
            <i className="bx bx-user font-size-16 align-middle me-1" />
            {t("Profile")}
          </Link>
          <div
            style={{ cursor: "pointer" }}
            className="dropdown-item"
            onClick={() => {
              history.push("/change-password");
            }}
          >
            <i className="bx bxs-lock-alt font-size-16 align-middle me-1 text-primary" />
            Thay đổi mật khẩu
          </div>
          <div
            // to={`https://inv.4si.vn/tools/4si_signer_windows.zip`}
            // target="_blank"
            // download
            style={{ cursor: "pointer" }}
            className="dropdown-item"
            onClick={() => {
              downloadToolUsbToken();
            }}
          >
            <i className="bx bx-usb font-size-16 align-middle me-1 text-info" />
            Tải file kết nối USB Token
          </div>
          <Link
            to={{ pathname: "https://einvoice.lcssoft.com.vn" }}
            target="_blank"
            rel="noopener noreferrer"
            className="dropdown-item"
          >
            <i className="bx bx-receipt font-size-16 align-middle me-1 text-primary" />
            Truy cập hệ thống TT32
          </Link>
          <Link
            to={{ pathname: "https://ics.lcsa.vn" }}
            target="_blank"
            rel="noopener noreferrer"
            className="dropdown-item"
          >
            <i className="bx bxs-receipt font-size-16 align-middle me-1 text-primary" />
            Truy cập hệ thống ICS
          </Link>
          <div className="dropdown-divider" />
          <Link to="/logout" className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
};

export default ProfileMenu;
